module.exports = "https://cdn.thelire.com/ins/resource/ico_order_successful@3x.e9e3a5ec48e2366933ecdcb58cd0f154.png";